var map = {
	"./action.page.tsx": 4942,
	"./change-password/change-password.page.ts": 3634,
	"./companies/companies.page.ts": 1354,
	"./fill-data/fill-data.page.ts": 9638,
	"./login/login.page.ts": 8271,
	"./mail-sent/mail-sent.page.ts": 2002,
	"./my-leads/my-leads.page.ts": 4984,
	"./plans/plans.page.ts": 4796,
	"./profile/profile.page.ts": 8007,
	"./reset/reset.page.ts": 1499,
	"./root.page.ts": 9308,
	"./signup/signup.page.ts": 673,
	"./verify/verify.page.ts": 7940
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3897;